import React from "react";
import Helpers from "../lib/helpers";
import { sanitizeUrlForMime } from "../lib/utils";

export default class VoiceSticker extends React.PureComponent {
   constructor(props) {
      super(props);

      this.handlePlayAudio = this.handlePlayAudio.bind(this);
   }

   handlePlayAudio() {
      try {
         let { audio } = this.props;
         const url = Helpers.getDownloadURL(audio);
         if (url.toLowerCase().endsWith('.mp3')) {
            const audioPlay = new Audio(url);
            audioPlay.play()
         }
      } catch (error) {

      }
   }

   render() {
      let { width, image, tinode } = this.props;
      const url = tinode.authorizeURL(sanitizeUrlForMime(Helpers.getDownloadURL(image), 'image'));
      return (
         <div onClick={this.handlePlayAudio}>
            <img src={url}
               class="inline-image"
               loading="lazy" style={{
                  width: width,
                  height: 'auto',
                  minWidth: width
               }} />
         </div>
      )
   }
}